import { render, staticRenderFns } from "./TrustBox.vue?vue&type=template&id=4e652bcd&"
import script from "./TrustBox.vue?vue&type=script&lang=js&"
export * from "./TrustBox.vue?vue&type=script&lang=js&"
import style0 from "./TrustBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports